import axios from 'axios';
import type { MenuItem } from '../interfaces';
import { getHeaders } from '@/@configs/axios';
import { Api } from '@/constants';
import { Features } from '@/models/bootstrap/plan';
import { privateRoutes } from '@/routes/private-routes';

export const menuItems: MenuItem[] = [
  { label: 'Cursos' },
  privateRoutes.Idp,
  privateRoutes.LearningPaths,
  privateRoutes.Subsidy,
  {
    label: 'Meu Eduplay',
    path: (ctx) =>
      ctx?.bootstrap?.info?.colaborador?.empresa?.feature_lms // legado
        ? '/corporate-university'
        : '/meu-aprendizado',
  },
  privateRoutes.AcademicHub,
  {
    label: (ctx) => ctx?.bootstrap?.plan?.zoom_config?.label ?? 'Acessar LMS',
    onClick: async () => {
      try {
        const { data } = await axios.get(
          `${Api.EdupassApi}/zoom_lms/sso_redirect`,
          { headers: getHeaders() }
        );
        const redirectUrl = data?.data?.redirectUrl;

        if (redirectUrl) {
          window.open(redirectUrl, '_blank');
        } else {
          throw new Error('Redirect URL ausente');
        }
      } catch (err) {
        alert(err);
      }
    },
    features: [Features.ZoomLms],
  },
];
